import {
  Modal, Button,
  ExclamationCircleOutlined,
  Colors
} from '../../../utils/commonImports';

const CustomModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  content, 
  confirmText = 'Yes', 
  cancelText = 'No',
  loading = false 
}) => {
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ExclamationCircleOutlined style={{ color: Colors.warning, fontSize: '18px' }} />
          {title}
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      maskClosable={true}
      centered
      width={400}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={loading}>
          {cancelText}
        </Button>,
        <Button 
          key="confirm" 
          type="primary" 
          onClick={onConfirm} 
          loading={loading}
          style={{
            backgroundColor: Colors.primary,
            borderColor: Colors.primary
          }}
        >
          {confirmText}
        </Button>
      ]}
    >
      <p style={{ margin: '16px 0', fontSize: '14px', color: Colors.gray }}>
        {content}
      </p>
    </Modal>
  );
};

export default CustomModal;